import { render } from "./icon-text.vue?vue&type=template&id=0630e018"
import script from "./icon-text.vue?vue&type=script&lang=ts"
export * from "./icon-text.vue?vue&type=script&lang=ts"
script.render = render

export default script